import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { JobTechService } from '@ftr/owa-jobs';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class LunchGuard  implements OnDestroy {
  private _techService = inject(JobTechService);
  private router = inject(Router);

  route!: ActivatedRouteSnapshot;
  isLunchOver: boolean = true;
  private statusSubscription?: Subscription;
  constructor() {
    this.statusSubscription = this._techService.profileStatusSubject.subscribe(x => {
      if (x.vxFieldStatus !== "LUNCH") {
        this.isLunchOver = true;
        if (this.router.url.includes('timer')) {
          this.router.navigate(['/']);
        }
      }
      else {
        this.isLunchOver = false;
      };
      
    })
  }

  ngOnDestroy() {
    this.statusSubscription?.unsubscribe()
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.canExit()
  }

  canExit() {
    if (!this.isLunchOver) {
      alert("Lunch is in progress...")
    }
    return this.isLunchOver;
  }
}